import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
  API_BASE_URL,
  DEFAULT_PAGE_DESCRIPTION,
  DEFAULT_PAGE_TITLE,
} from "../../utilities/constants";
import { useParams } from 'react-router-dom';
import { handleApiCall } from "../../utilities/helper";
import LeaderCard from "../insiders/LeaderCards";

const StylistDetails = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [controller, setController] = useState(null);
  const { id } = useParams();

  const callListApi = async () => {
    controller?.abort();
    const newController = new AbortController();
    setController(newController);
    const { signal } = newController;
    setLoading(true);
    try {
      const response = await handleApiCall(
        `${API_BASE_URL}/api/1.0.0/aistylist/v2/stylist/${id}`,
        {
          method: "GET"
        },
        null,
        signal
      );
      if (response.responseStatus == true) {
        setData(response.data);

      } else {
        setData(null);
      }
      if (response.responseCode !== 299) {
        setLoading(false);
      }
    } catch (e) {
      console.error("Error", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      callListApi();
      setLoading(false);
    }
  }, [id]);

  let parsedAttributes = {};
  try {
    parsedAttributes = JSON.parse(data?.attributes || "{}");
  } catch (e) {
    console.error("Invalid attributes JSON", e);
  }

  return (
    <>
      <PageMeta
        title={`Stylist Details - ${DEFAULT_PAGE_TITLE}`}
        description={`Stylist Details - ${DEFAULT_PAGE_DESCRIPTION}`}
      />

      <div className="flex justify-between items-center mb-4">
        <PageBreadcrumb
          pageTitle="Stylist Details"
          breadcrumbs={[
            { label: "Stylist", path: "/stylists" },
            { label: "Stylist Details" }
          ]}
        />
      </div>
      {loading ? (
        <div className="flex justify-center items-center">
          <Spinner />
        </div>
      ) : (
        <div className="p-6 bg-white dark:bg-gray-800 rounded-lg mx-auto h-full">
          <div className="flex flex-col md:flex-row gap-10">
            {/* Profile Image  */}
            <div className="w-full md:w-1/4 rounded-lg overflow-hidden bg-gray-100 dark:bg-gray-700">
              {data && (
                <LeaderCard
                  images={data?.media
                    ?.filter(m => m?.mediaType === "PROFILE")
                    ?.map(m => m?.mediaUrl)}
                  showArrows={true}
                />
              )}
            </div>

            <div className="flex-1 flex flex-col justify-center gap-4">
              <div>
                <h3 className="text-sm text-gray-500 dark:text-gray-400">Name</h3>
                <p className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                  {data?.displayName}
                </p>
              </div>

              <div>
                <h3 className="text-sm text-gray-500 dark:text-gray-400">Persona</h3>
                <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                  {data?.persona}
                </p>
              </div>
              <div>
                <h3 className="text-sm text-gray-500 dark:text-gray-400">Ethos</h3>
                <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                  {data?.ethos}
                </p>
              </div>
              {parsedAttributes?.color?.palette && (
                <div>
                  <h3 className="text-sm text-gray-500 dark:text-gray-400">Color Palette</h3>
                  <div className="flex gap-2 mt-1">
                    {parsedAttributes.color.palette.map((hex, i) => (
                      <div
                        key={i}
                        className="w-6 h-6 rounded-full border"
                        style={{ backgroundColor: hex }}
                      />
                    ))}
                  </div>
                </div>
              )}

              {parsedAttributes?.materials?.prefer && (
                <div>
                  <h3 className="text-sm text-gray-500 dark:text-gray-400">Materials</h3>
                  <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                    {parsedAttributes.materials.prefer.join(", ")}
                  </p>
                </div>
              )}

              {parsedAttributes?.photo?.lighting && (
                <div>
                  <h3 className="text-sm text-gray-500 dark:text-gray-400">Lighting</h3>
                  <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                    {parsedAttributes.photo.lighting}
                  </p>
                </div>
              )}
            </div>

          </div>

          {/* Work Images */}
          <div className="mt-10">
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
              Work Inspiration
            </h3>
            <div className="w-full rounded-lg overflow-hidden">
              <LeaderCard
                stylistsworlmedia={data?.media
                  ?.filter(m => m.mediaType === "WORK")
                  ?.map(m => ({ image: m.mediaUrl, caption: m.caption }))}
              />
            </div>
          </div>

          {/* Mood Board */}
          <div className="mt-10">
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
              Mood Board
            </h3>
            <div className="w-full rounded-lg overflow-hidden">
              <LeaderCard
                moodboard={data?.media
                  ?.filter(m => m.mediaType === "MOODBOARD")
                  ?.map(m => ({ image: m.mediaUrl, caption: m.caption }))}
              />
            </div>
          </div>
        </div>

      )}

    </>
  );
}
export default StylistDetails;
